module.exports = __webpack_public_path__ + "static/media/IconDownload.56455598.svg";